import { render, staticRenderFns } from "./DeliveryPointsView.vue?vue&type=template&id=31730954&scoped=true&"
import script from "./DeliveryPointsView.vue?vue&type=script&lang=js&"
export * from "./DeliveryPointsView.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=31730954&scoped=true&lang=css&"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=31730954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31730954",
  null
  
)

export default component.exports